export const styles = {
	textFieldMarginTop: { width: "100%", marginTop: 8 },
	fullWidth: { width: "100%" },
	divider: { margin: "16px 0 16px 0" },
	formControl: { width: "100%", margin: 0, marginTop: 8 },
	active: { display: "flex", alignItems: "center", justifyContent: "center" },
	alertMargin: { width: "95%", marginTop: 12 },
	button: { height: 50, alignSelf: "flex-end", width: "100%" },
}
